import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../components/ui/card";
import { OverviewChart } from "components";

const Daily = () => {
  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Daily</h1>
        <p className="text-muted-foreground">
          Daily sales and performance metrics.
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Daily Overview</CardTitle>
          <CardDescription>
            View daily sales performance and trends.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="h-96">
            <OverviewChart view="sales" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Daily;
